import React from 'react';
import classes from './Tooltip.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faQuestionCircle);

const ToolTip = props => (
	<div className={classes.tooltipContainer}>
		<div className={classes.tooltip}>
			<FontAwesomeIcon className={classes.faInfoCircle} icon={faQuestionCircle} />
			<span className={classes.tooltiptext}>
				<div>
					<p>{props.text}</p>
				</div>
			</span>
		</div>
	</div>
);

export default React.memo(ToolTip);
